import { Component, Element, h, Host, Prop } from "@stencil/core";
import { SearchTagTypeEnum } from "./interface";

const baseClass = "ux-iws-search-tag-group";

@Component({
    tag: "ux-iws-search-tag-group",
    styleUrl: "search-tag-group.scss",
})
export class SearchTagGroup {
    @Element() element: HTMLUxIwsSearchTagGroupElement;

    /** Name of the filter group used for the tag's input name attribute */
    @Prop() name: string;
    /** Nesting level of the filter group */
    @Prop() level: number = 0;
    /** Controls if the filter tags are shown or not */
    @Prop() expanded: boolean = false;
    /** The selected tag */
    @Prop() selectedTag: {
        label: string;
        name: string;
        value?: string;
    } | null = null;

    render() {
        const { expanded, selectedTag } = this;
        const isActive = selectedTag !== null;
        const isExpanded = expanded || !isActive;
        return (
            <Host
                class={{
                    [`${baseClass}`]: true,
                    [`${baseClass}--active`]: isActive,
                    [`${baseClass}--expanded`]: isExpanded,
                    [`${baseClass}--collapsed`]: !isExpanded,
                }}
            >
                <div class={`${baseClass}__selection`}>
                    {selectedTag && !isExpanded && (
                        <ux-iws-search-tag
                            type={SearchTagTypeEnum.Group}
                            value={selectedTag.value}
                        >
                            {selectedTag.label}
                        </ux-iws-search-tag>
                    )}
                </div>
                <div class={`${baseClass}__tags`}>
                    <slot />
                </div>
            </Host>
        );
    }
}
